import { render, staticRenderFns } from "./PhoneEnquiryIcon.vue?vue&type=template&id=c05f323c&"
import script from "./PhoneEnquiryIcon.vue?vue&type=script&lang=js&"
export * from "./PhoneEnquiryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports